import React from 'react';
import { RatingProps, CustomIconsType, Rating } from '../../../Atoms/Rating';
import { Icons } from '../../../Foundation/Icons';

import { RatingWrapper } from './StarRating.styles';

const { Star } = Icons;

export const StarRating = (props: RatingProps): JSX.Element => {
  const {
    iconSize,
    label1,
    label2,
    label3,
    label4,
    label5,
    iconColor,
    highlightColor,
  } = props;
  const customIcons: CustomIconsType = {
    1: {
      icon: <Star />,
      label: label1,
    },
    2: {
      icon: <Star />,
      label: label2,
    },
    3: {
      icon: <Star />,
      label: label3,
    },
    4: {
      icon: <Star />,
      label: label4,
    },
    5: {
      icon: <Star />,
      label: label5,
    },
  };
  return (
    <RatingWrapper
      iconSize={iconSize}
      iconColor={iconColor}
      highlightColor={highlightColor}
    >
      <Rating customIcons={customIcons} {...props} />
    </RatingWrapper>
  );
};
